<template>
  <div>
      <breadcrumbs />
    <div 
      v-if="ready && !detailPageOpen"
      class="columns is-multiline is-centered search-bar"
    >
      <div class="column is-10">
        <h1 class="is-size-3">
          <!-- <button
            class="back"
            @click.prevent="clickBackButton"
          >
            <i class="fa fa-arrow-circle-left fa-2x" aria-hidden="true"></i>
          </button> -->
          Property address search
        </h1>
      </div>
      <div
        ref="searchArea"
        class="column is-10"
      >

      <!-- TODO Hide if search result completed and new view showing, so mostly stays the same. -->
        <SearchBox
          v-model="searchInput"
          :placeholder="placeholder"
          @searchclear="searchInput = ''; suggestions = []"
          :handleSearchFormSubmit="historySearch"
          @input.native="loadSuggestions($event.target.value)"
          @keydown.native.down="focusFirstSuggestion"
        >
          <template v-slot:address-candidates-slot>
            <SearchSuggestions
              ref="suggestions"
              :suggestions="suggestions"
              @select="selectSuggestion"
              @dismiss="dismissSuggestions"
            />
          </template>
        </SearchBox>

        <!-- TODO keep this error page here -->
      </div>
    </div>
    <div
      class="columns is-12 is-centered"
    >
        <router-view
          v-if="ready && status !== 'loading'"
          class="column is-12"
          :contents="resultsData()"
          :searchTerm="searchInput"
          :key="$route.fullPath"
        />
        <div
          v-show="status === 'loading'"
          class="columns is-centered"
        >
          <i class="fas fa-spinner fa-spin fa-3x" />
        </div>
    </div>
    <div class="columns is-centered">
      <div 
        v-if="ready && status !== 'results' && status !== 'error' && status !== 'loading' && !this.$store.state.detailPage"
        class="search-bar-content column is-5 "
      >
        <h3 class="is-size-3">
        Enter an address  in the search bar to see 
        permits, licenses, violations, and appeals.
        </h3>
        <p class="is-size-7">
          For additional license and permit searches,
          <a 
            class="has-text-weight-semibold"
            href="https://eclipse.phila.gov/phillylmsprod/pub/lms/Login.aspx"
            target="_blank"
          >
            view in eCLIPSE</a>.
        </p>
      </div>
      <div 
          class="search-error search-bar-content"
          v-if="status === 'error'"
        >
          <p><span class="red">!</span> No results found for {{ searchInputCalc }}. </p>
      </div> 
    </div>
  </div>
</template>
<script>
import SearchBox from '@/components/SearchBox';
import SearchSuggestions from '@/components/SearchSuggestions';
import { fetchAddressSuggestions } from '@/util/databridge.js';
export default {
  name: 'PropertyHistory',
  props: {
    },
  data() {
    return {
      searchInput: "",
      status: 'search',
      ready: false,
      placeholder: "Search an address...",
      suggestions: [],
      // counts suggestion requests so a slow reply to older typing can't overwrite a newer one
      suggestionRequest: 0,
    }
  },
  components: {
    SearchBox,
    SearchSuggestions,
  },
  mounted() {
    document.addEventListener('mousedown', this.hideSuggestionsOnOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.hideSuggestionsOnOutsideClick);
  },
  async created(){
    // console.log("Created running", this.$store.state.propertyHistorySearchStatus);
    if (!this.$store.state.propertyHistorySearchStatus && this.$route.query.address) {
      try {
        await this.getData(this.$route.query.address);
      } catch (err) {
        console.log("Oops", err);
      }
    }
    this.$store.commit('updateHeader', 'propertyHistory');
    this.ready = true;

  },
  destroyed(){
    this.$store.commit('updateHeader', null);
  },
  computed: {
    detailPageOpen(){
      return this.$store.state.detailPage
    },
    searchInputCalc(){
      return this.$route.query.address
    }
  },
  methods: {
    async getData(input) {
      // console.log("Getting Data", input)
      this.status = 'loading';
      try {
        await this.$store.dispatch("getDataByAddress", input);
        // console.log("Dispatch done");
        this.status = 'results';
        this.searchInput = this.$store.state.searchResults.opa_address !== "" ? this.$store.state.searchResults.opa_address : this.$store.state.searchResults.street_address;
        this.ready = true;
      } catch (err) {
          console.log("Response errored: ", err);
          this.ready= true;
          this.status = 'error';
      }
    },
    // fed by the input's native input event, not v-model: Vue holds v-model back while an
    // Android keyboard is still composing a word, which would freeze the list mid-typing
    async loadSuggestions(value) {
      const request = ++this.suggestionRequest;
      const suggestions = await fetchAddressSuggestions(value);
      if (request !== this.suggestionRequest) return;
      this.suggestions = suggestions;
    },
    selectSuggestion(suggestion) {
      this.searchInput = suggestion;
      this.suggestions = [];
      this.historySearch();
    },
    searchInputElement() {
      return this.$refs.searchArea ? this.$refs.searchArea.querySelector('input') : null;
    },
    dismissSuggestions() {
      this.suggestions = [];
      const input = this.searchInputElement();
      if (input) input.focus();
    },
    focusFirstSuggestion(event) {
      // only from the search input itself - the list handles its own arrow keys
      if (event.target !== this.searchInputElement() || !this.suggestions.length) return;
      event.preventDefault();
      this.$refs.suggestions.focusFirst();
    },
    hideSuggestionsOnOutsideClick(event) {
      if (!this.suggestions.length) return;
      if (this.$refs.searchArea && !this.$refs.searchArea.contains(event.target)) {
        this.suggestions = [];
      }
    },
    async historySearch() {
      // console.log("History Search Button", this, this.searchInput);
      this.suggestions = [];
      await this.getData( this.searchInput);
      // console.log("History Search Button", this.status );
      this.status === 'results' ? this.$router.push(
          { name: 'address-search',
            query: { address: this.searchInput},
          }).catch(()=>{}) :
        this.status === 'error' ? this.$router.push(
          { name: 'search-error',
            query: { address: this.searchInput},
            params:  { searchTerm: this.searchInput }
          }).catch(()=>{}) :
        this.status = 'search';
    },
    // async clickBackButton(){
    //   // console.log("Back button", this.$route.name);
    //   // this.ready = false;
    //   if( this.$route.name === "address-search" | this.$route.name === "propertyHistory") {
    //     return this.$router.push({name: 'dashboard'});
    //   } 

    //   await this.$store.commit('closeDetail', this.$route);
    //   this.$router.go(-1)
      
    // },
    resultsData() {
      let resultsArray = [];
      let state = this.$store.state;
      // resultsArray.push(state.appealsResults, state.buildingCertificationSummaryResults, state.buildingCertResults, state.investigationsResults, state.licenseResults, state.permitResults, state.violationsTableResults);
      resultsArray.push(state.appealsResults, state.buildingCertificationSummaryResults, state.investigationsResults, state.licenseResults, state.permitResults, state.violationsTableResults);
      return resultsArray;
    }
  },
};
</script>
<style lang="scss">
@media screen and (max-width: 768px) {
  #app > main {
      display: inline;
  }
  .search-bar {
    margin: 0px -16px 0 -16px;
  }
  .search-bar, .results-address-box {
    padding: 15px;
    display: flow-root;
    div>div.is-10, div>div>form {
      margin: 0 15px 0 15px;
    }
  }

  main.main>div>div.bottom-grey-header {
    position: fixed;
  }

}

</style>
<style lang="scss" scoped>
  // h1 {
  //   margin-bottom: 25px;
  //   line-height: 1.75rem;
  // }

  div.column>.input-wrap {
    padding: 0;
  }
  .detail {
    margin: auto;
  }
  .search-bar {
    background-color: $ben-franklin-blue-light;
    padding: 15px;
    &.columns {
      margin-top: 0;
      margin-bottom: 0;
    }

    .column {
      padding-top: 5px;
      padding-bottom:5px;
    }
  }
  .search-bar-content {
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
    h3 {
      color: $grey-dark;
      margin-bottom: 50px;
    }
    p>a::after {
    font-family: "Font Awesome 5 Pro";
    content: "\f08e";
    font-size: smaller;
    padding-left: 2px;
    }
  }
  .bottom-grey-header{
    background-color: $ghost-grey;
    bottom: 0;
    position: absolute;
    width: 100%;
    left: 0;
    text-align: center;
    padding: 25px;
    font-size: larger;
  }
</style>
